import { SHOW_DETAILED_SITE_INFO, CLOSE_DETAILED_SITE_INFO } from 'widget/universal/actions/ordering/ActionTypes'

export const showDetailedSiteInfo = () => ({
  type: SHOW_DETAILED_SITE_INFO,
})

export const closeDetailedSiteInfo = () => ({
  type: CLOSE_DETAILED_SITE_INFO,
})
